export default [
    {
       path: "/coffee",
       name: "coffee",
       meta: {
         title: "咖啡",
         keepAlive: true,
         footer: false,
         movieFooter: false,
         home:false,
         backgroundColor: "#fff"
      },
       component: ()=>import ("@views/coffee/CoffeeOrder.vue")
    },
	// {
	//    path: "/CoffeeOrderList/:id",
	//    name: "CoffeeOrderList",
	//    meta: {
	//      title: "咖啡订单",
	//      keepAlive: false,
	//      footer: false,
	//      auth: false, //
	//      home: true
	//   },
	//    component: ()=>import ("@views/coffee/CoffeeOrderList.vue")
	// },
	{
	    path: "/coffeeOrderList/:id",
	    name: "CoffeeOrderList",
	    meta: {
	        title: "订单",
	        keepAlive: false,
	        footer: false,
	        movieFooter: false,
	        // movieFooter: true,底部导航
	        home:false,
	        auth: true
	    },
	   component: ()=>import ("@views/coffee/CoffeeOrderList.vue")
	},
];